module.exports = __webpack_public_path__ + "yellow.jpg?470708745c87d2be50013e654c1b2ca2";